module.exports = __webpack_public_path__ + "static/img/fclab-blood-tube.efafedf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/fclab-blood-tube.jpg
// module id = 7+Um
// module chunks = 0